// C:\Users\green\szaportal\src\WebServer\NewGenome\modules\Home\Home.js
// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Home.css';
import ResultsModal from './ResultsModal';
import { getApiEndpoint } from '../../config/newgenome-config';
import logoDark from '../../../../varxomics.png';
import logoLight from '../../../../varxomics_dark.png';
import {
  JOB_TYPE_METADATA,
  JOB_TYPE_ORDER,
  getJobTypeMeta,
  formatJobTypeLabel
} from './jobTypeMeta';
import { ensureNewGenomeProCookie } from '../../WebserverUser';

const INHERITANCE_OPTIONS = [
  { value: '', label: 'Any pattern' },
  { value: 'AD', label: 'Autosomal Dominant (AD)' },
  { value: 'AR', label: 'Autosomal Recessive (AR)' },
  { value: 'de_novo', label: 'De novo' },
  { value: 'X-linked', label: 'X-linked' },
];

const CLINVAR_STATUS_OPTIONS = [
  { value: 'Pathogenic', label: 'Pathogenic' },
  { value: 'Likely_pathogenic', label: 'Likely Pathogenic' },
  { value: 'Uncertain_significance', label: 'Uncertain Significance' },
  { value: 'Conflicting_classifications_of_pathogenicity', label: 'Conflicting Classifications' },
  { value: 'Benign', label: 'Benign' },
  { value: 'Likely_benign', label: 'Likely Benign' },
  { value: 'not_provided', label: 'Not Provided' }
];

const ACMG_CLASSIFICATION_OPTIONS = [
  { value: 'Pathogenic', label: 'Pathogenic' },
  { value: 'Likely_pathogenic', label: 'Likely Pathogenic' },
  { value: 'Uncertain_significance', label: 'Uncertain Significance' },
  { value: 'Benign', label: 'Benign' },
  { value: 'Likely_benign', label: 'Likely Benign' }
];

const AM_CLASSIFICATION_OPTIONS = [
  { value: 'pathogenic', label: 'Pathogenic' },
  { value: 'likely_pathogenic', label: 'Likely Pathogenic' },
  { value: 'ambigous', label: 'Ambiguous' },
  { value: 'uncertain_significance', label: 'Uncertain Significance' },
  { value: 'benign', label: 'Benign' },
  { value: 'likely_benign', label: 'Likely Benign' },
  { value: 'risk_factor', label: 'Risk Factor' }
];

const FIELD_SECTIONS = [
  {
    key: 'sample',
    title: 'Sample Filters',
    description: 'Baseline metadata that scopes the multi-variant run.',
    fields: [
      {
        type: 'select',
        name: 'genome',
        label: 'Reference Genome',
        options: [
          { value: 'GRCH38', label: 'GRCh38' },
          { value: 'GRCH37', label: 'GRCh37' }
        ]
      },
      {
        type: 'select',
        name: 'gender',
        label: 'Gender',
        options: [
          { value: 'Unknown', label: 'Unknown' },
          { value: 'Female', label: 'Female' },
          { value: 'Male', label: 'Male' }
        ]
      },
      {
        type: 'select',
        name: 'onlyPass',
        label: 'Only PASS Variants',
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      },
      {
        type: 'select',
        name: 'inheritance',
        label: 'Inheritance Pattern',
        options: INHERITANCE_OPTIONS,
        allowsCustom: true
      },
      {
        type: 'text',
        name: 'hpo',
        label: 'HPO Terms (CSV)',
        placeholder: 'e.g., HP:0001250,HP:0000707',
        fullWidth: true
      }
    ]
  },
  {
    key: 'allele-frequency',
    title: 'Allele Frequency',
    description: 'Tune population frequency thresholds.',
    fields: [
      {
        type: 'number',
        name: 'afClinvar',
        label: 'AF ClinVar',
        min: 0,
        step: 0.01,
        hint: 'Cap for ClinVar-derived evidence.'
      },
      {
        type: 'range',
        name: 'afPrediction',
        label: 'AF (Predicted variants)',
        min: 0,
        max: 1,
        step: 0.01,
        hint: 'Allele frequency cutoff for predicted variants.'
      }
    ]
  },
  {
    key: 'predictors',
    title: 'Predictive Scores',
    description: 'Min confidence thresholds for ensemble predictors.',
    fields: [
      {
        type: 'range',
        name: 'ada',
        label: 'ADA',
        min: 0,
        max: 1,
        step: 0.01
      },
      {
        type: 'range',
        name: 'rf',
        label: 'RF',
        min: 0,
        max: 1,
        step: 0.01
      },
      {
        type: 'range',
        name: 'revel',
        label: 'REVEL',
        min: 0,
        max: 1,
        step: 0.01
      }
    ]
  },
  {
    key: 'spliceai',
    title: 'SpliceAI Thresholds',
    description: 'Per-dimension thresholds for splice impact predictions.',
    fields: [
      {
        type: 'range',
        name: 'spliceaiAl',
        label: 'Acceptor Loss (AL)',
        min: 0,
        max: 1,
        step: 0.01
      },
      {
        type: 'range',
        name: 'spliceaiAg',
        label: 'Acceptor Gain (AG)',
        min: 0,
        max: 1,
        step: 0.01
      },
      {
        type: 'range',
        name: 'spliceaiDl',
        label: 'Donor Loss (DL)',
        min: 0,
        max: 1,
        step: 0.01
      },
      {
        type: 'range',
        name: 'spliceaiDg',
        label: 'Donor Gain (DG)',
        min: 0,
        max: 1,
        step: 0.01
      }
    ]
  },
  {
    key: 'bayesdel',
    title: 'BayesDel',
    description: 'Thresholds for Bayesian deleteriousness scores.',
    fields: [
      {
        type: 'range',
        name: 'bayesdelAddAf',
        label: 'BayesDel (with AF)',
        min: -1,
        max: 1,
        step: 0.001
      },
      {
        type: 'range',
        name: 'bayesdelNoAf',
        label: 'BayesDel (no AF)',
        min: -1,
        max: 1,
        step: 0.001,
        hint: 'Keep in sync with backend default.'
      }
    ]
  },
  {
    key: 'classification',
    title: 'Classification Filters',
    description: 'Restrict to specific ACMG/AMP outputs.',
    fields: [
      {
        type: 'tiles',
        name: 'amClassification',
        label: 'AM Classification',
        options: AM_CLASSIFICATION_OPTIONS,
        hint: 'Pick the AMP tiers to keep.',
        fullWidth: true
      },
      {
        type: 'range',
        name: 'amPathogenicity',
        label: 'AM Pathogenicity',
        min: 0,
        max: 1,
        step: 0.001,
        fullWidth: true
      },
      {
        type: 'tiles',
        name: 'clinvar',
        label: 'ClinVar Status',
        options: CLINVAR_STATUS_OPTIONS,
        hint: 'Select one or more ClinVar review statuses.',
        fullWidth: true
      },
      {
        type: 'tiles',
        name: 'acmgClassification',
        label: 'ACMG Classification',
        options: ACMG_CLASSIFICATION_OPTIONS,
        hint: 'Select ACMG evidence tiers to include.',
        fullWidth: true
      }
    ]
  }
];

const MultiVariantModal = ({ isOpen, onClose, onSubmit }) => {
  // All params with defaults matching backend/bash expectations
  const [parameters, setParameters] = useState({
    genome: 'GRCH38',
    gender: 'Unknown',
    onlyPass: 'yes',
    hpo: '',
    inheritance: '',

    afClinvar: '1',
    afPrediction: '0.05',

    ada: '0.6',
    rf: '0.6',
    revel: '0.75',

    spliceaiAl: '0.5',
    spliceaiAg: '0.5',
    spliceaiDl: '0.5',
    spliceaiDg: '0.5',

    bayesdelAddAf: '0.069',
    bayesdelNoAf: '-0.057', // keep in sync with backend default

    amClassification: 'likely_pathogenic,ambigous',
    amPathogenicity: '0.564',

    clinvar:
      'Pathogenic,Likely_pathogenic,Uncertain_significance,Conflicting_classifications_of_pathogenicity',
    acmgClassification:
      'Pathogenic,Likely_pathogenic,Uncertain_significance,Benign,Likely_benign'
  });
  const [useCustomInheritance, setUseCustomInheritance] = useState(false);

  const parseCsv = (value = '') =>
    value
      .split(',')
      .map(token => token.trim())
      .filter(Boolean);

  const toggleCsvValue = (fieldName, nextValue) => {
    setParameters(prev => {
      const current = parseCsv(prev[fieldName]);
      const hasValue = current.includes(nextValue);
      const updated = hasValue
        ? current.filter(item => item !== nextValue)
        : [...current, nextValue];
      return { ...prev, [fieldName]: updated.join(',') };
    });
  };

  useEffect(() => {
    if (!isOpen) return;
    const matchesPreset = INHERITANCE_OPTIONS.some(
      option => option.value === parameters.inheritance
    );

    const shouldUseCustom = Boolean(parameters.inheritance) && !matchesPreset;
    if (shouldUseCustom !== useCustomInheritance) {
      setUseCustomInheritance(shouldUseCustom);
    }
  }, [isOpen, parameters.inheritance, useCustomInheritance]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setParameters(prev => ({ ...prev, [name]: value }));
  };

  const handleInheritanceSelect = (value) => {
    if (value === '__custom__') {
      setUseCustomInheritance(true);
      return;
    }
    setUseCustomInheritance(false);
    setParameters(prev => ({ ...prev, inheritance: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Trim simple strings so we don't send "  HP:..." etc.
    const trimmed = Object.fromEntries(
      Object.entries(parameters).map(([k, v]) =>
        typeof v === 'string' ? [k, v.trim()] : [k, v]
      )
    );
    onSubmit(trimmed);
  };

  const renderRangeField = (field) => {
    const sliderValue = parameters[field.name] === ''
      ? (field.min !== undefined ? String(field.min) : '0')
      : parameters[field.name];

    return (
      <div
        key={field.name}
        className={`WSNG-modal-form-group WSNG-modal-form-group--range${field.fullWidth ? ' full-width' : ''}`}
      >
        <label htmlFor={field.name}>
          {field.label}
          <span className="WSNG-modal-range-value">{parameters[field.name] || sliderValue}</span>
        </label>
        <div className="WSNG-modal-range-wrapper">
          <input
            type="range"
            id={field.name}
            name={field.name}
            min={field.min}
            max={field.max}
            step={field.step ?? 0.01}
            value={sliderValue}
            onChange={handleInputChange}
          />
          <input
            type="number"
            id={`${field.name}-number`}
            name={field.name}
            min={field.min}
            max={field.max}
            step={field.step ?? 0.01}
            value={parameters[field.name]}
            onChange={handleInputChange}
            className="WSNG-modal-range-input"
          />
        </div>
        {field.hint && <p className="WSNG-modal-hint">{field.hint}</p>}
      </div>
    );
  };

  const renderSelectField = (field) => {
    const value = field.allowsCustom
      ? (useCustomInheritance ? '__custom__' : parameters[field.name] ?? '')
      : parameters[field.name] ?? '';

    const onChange = (event) => {
      if (field.allowsCustom) {
        handleInheritanceSelect(event.target.value);
      } else {
        handleInputChange(event);
      }
    };

    return (
      <div
        key={field.name}
        className={`WSNG-modal-form-group${field.fullWidth ? ' full-width' : ''}`}
      >
        <label htmlFor={field.name}>{field.label}</label>
        <select
          id={field.name}
          name={field.name}
          value={value}
          onChange={onChange}
        >
          {field.options.map(option => (
            <option key={option.value || option.label} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {field.allowsCustom && useCustomInheritance && (
          <input
            type="text"
            id={`${field.name}-custom`}
            name="inheritance"
            value={parameters.inheritance}
            onChange={handleInputChange}
            placeholder="e.g., AR / AD / de_novo / X-linked"
            className="WSNG-modal-custom-input"
          />
        )}
        {field.hint && <p className="WSNG-modal-hint">{field.hint}</p>}
      </div>
    );
  };

  const renderTextField = (field) => (
    <div
      key={field.name}
      className={`WSNG-modal-form-group${field.fullWidth ? ' full-width' : ''}`}
    >
      <label htmlFor={field.name}>{field.label}</label>
      <input
        type="text"
        id={field.name}
        name={field.name}
        value={parameters[field.name]}
        onChange={handleInputChange}
        placeholder={field.placeholder}
      />
      {field.hint && <p className="WSNG-modal-hint">{field.hint}</p>}
    </div>
  );

  const renderNumberField = (field) => (
    <div
      key={field.name}
      className={`WSNG-modal-form-group${field.fullWidth ? ' full-width' : ''}`}
    >
      <label htmlFor={field.name}>{field.label}</label>
      <input
        type="number"
        id={field.name}
        name={field.name}
        min={field.min}
        max={field.max}
        step={field.step ?? 'any'}
        value={parameters[field.name]}
        onChange={handleInputChange}
      />
      {field.hint && <p className="WSNG-modal-hint">{field.hint}</p>}
    </div>
  );

  const renderTextareaField = (field) => (
    <div
      key={field.name}
      className={`WSNG-modal-form-group${field.fullWidth ? ' full-width' : ''}`}
    >
      <label htmlFor={field.name}>{field.label}</label>
      <textarea
        id={field.name}
        name={field.name}
        rows={field.rows ?? 3}
        value={parameters[field.name]}
        onChange={handleInputChange}
      />
      {field.hint && <p className="WSNG-modal-hint">{field.hint}</p>}
    </div>
  );

  const renderTilesField = (field) => {
    const selectedValues = parseCsv(parameters[field.name]);

    return (
      <div
        key={field.name}
        className={`WSNG-modal-form-group WSNG-modal-form-group--tiles${field.fullWidth ? ' full-width' : ''}`}
      >
        <label htmlFor={field.name}>{field.label}</label>
        <div className="WSNG-modal-tile-group" id={field.name} role="group" aria-label={field.label}>
          {field.options.map(option => {
            const isSelected = selectedValues.includes(option.value);
            return (
              <button
                type="button"
                key={option.value}
                className={`WSNG-modal-tile${isSelected ? ' selected' : ''}`}
                onClick={() => toggleCsvValue(field.name, option.value)}
              >
                <span className="WSNG-modal-tile-label">{option.label}</span>
              </button>
            );
          })}
        </div>
        {field.hint && <p className="WSNG-modal-hint">{field.hint}</p>}
      </div>
    );
  };

  const renderField = (field) => {
    switch (field.type) {
      case 'range':
        return renderRangeField(field);
      case 'select':
        return renderSelectField(field);
      case 'textarea':
        return renderTextareaField(field);
      case 'number':
        return renderNumberField(field);
      case 'tiles':
        return renderTilesField(field);
      default:
        return renderTextField(field);
    }
  };

  return (
    <div className="WSNG-modal-overlay">
      <div className="WSNG-modal-content">
        <h2 className="WSNG-modal-title"><i className="fas fa-cogs"></i> Multi-Variant Analysis Settings</h2>
        <p className="WSNG-modal-description">Configure parameters for the VarXOmics pipeline.</p>

        <form onSubmit={handleSubmit} className="WSNG-modal-form">
          <div className="WSNG-modal-fields">
            {FIELD_SECTIONS.map(section => (
              <section key={section.key} className="WSNG-modal-section">
                <div className="WSNG-modal-section-heading">
                  <h3>{section.title}</h3>
                  <p>{section.description}</p>
                </div>
                <div className="WSNG-modal-grid">
                  {section.fields.map(renderField)}
                </div>
              </section>
            ))}
          </div>

          <div className="WSNG-modal-actions">
            <button type="button" className="WSNG-modal-btn secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="WSNG-modal-btn primary"><i className="fas fa-play"></i> Start Analysis</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const MultiSvCnvModal = ({ isOpen, onClose, onSubmit }) => {
  const [genome, setGenome] = useState('GRCH38');
  const [dataType, setDataType] = useState('cnv'); // State for the new dropdown

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Pass both genome and the new dataType on submit
    onSubmit({ genome, dataType });
  };

  return (
    <div className="WSNG-modal-overlay">
      <div className="WSNG-modal-content">
        <h2 className="WSNG-modal-title"><i className="fas fa-project-diagram"></i> Multiple SV/CNV Analysis Settings</h2>
        <p className="WSNG-modal-description">Configure parameters for your structural variant analysis.</p>

        <form onSubmit={handleSubmit} className="WSNG-modal-form">
          <div className="WSNG-modal-fields">
            <section className="WSNG-modal-section">
              <div className="WSNG-modal-section-heading">
                <h3>Analysis Parameters</h3>
                <p>Select the reference genome and the type of variants in your VCF file.</p>
              </div>
              <div className="WSNG-modal-grid">
                {/* Genome Dropdown */}
                <div className="WSNG-modal-form-group">
                  <label htmlFor="genome">Reference Genome</label>
                  <select
                    id="genome"
                    name="genome"
                    value={genome}
                    onChange={(e) => setGenome(e.target.value)}
                  >
                    <option value="GRCH38">GRCh38</option>
                    <option value="GRCH37">GRCh37</option>
                  </select>
                </div>

                {/* --- THIS IS THE NEW DROPDOWN TO ADD --- */}
                <div className="WSNG-modal-form-group">
                  <label htmlFor="dataType">Data Type</label>
                  <select
                    id="dataType"
                    name="dataType"
                    value={dataType}
                    onChange={(e) => setDataType(e.target.value)}
                  >
                    <option value="cnv">Copy Number Variation (CNV)</option>
                    <option value="sv">Structural Variation (SV)</option>
                  </select>
                </div>
              </div>
            </section>
          </div>

          <div className="WSNG-modal-actions">
            <button type="button" className="WSNG-modal-btn secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="WSNG-modal-btn primary"><i className="fas fa-play"></i> Start Analysis</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const SingleVariantModal = ({ isOpen, onClose, onSubmit }) => {
  const [genome, setGenome] = useState('GRCH38');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ genome });
  };

  return (
    <div className="WSNG-modal-overlay">
      <div className="WSNG-modal-content">
        <h2 className="WSNG-modal-title"><i className="fas fa-code-branch"></i> Single Variant Analysis Settings</h2>
        <p className="WSNG-modal-description">Configure parameters for your variant analysis.</p>

        <form onSubmit={handleSubmit} className="WSNG-modal-form">
          <div className="WSNG-modal-fields">
            <section className="WSNG-modal-section">
              <div className="WSNG-modal-section-heading">
                <h3>Analysis Parameters</h3>
                <p>Select the reference genome build.</p>
              </div>
              <div className="WSNG-modal-grid">
                <div className="WSNG-modal-form-group">
                  <label htmlFor="genome">Reference Genome</label>
                  <select
                    id="genome"
                    name="genome"
                    value={genome}
                    onChange={(e) => setGenome(e.target.value)}
                  >
                    <option value="GRCH38">GRCh38</option>
                    <option value="GRCH37">GRCh37</option>
                  </select>
                </div>
              </div>
            </section>
          </div>

          <div className="WSNG-modal-actions">
            <button type="button" className="WSNG-modal-btn secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="WSNG-modal-btn primary"><i className="fas fa-play"></i> Start Analysis</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const SingleSvCnvModal = ({ isOpen, onClose, onSubmit }) => {
  const [genome, setGenome] = useState('GRCH38');
  const [dataType, setDataType] = useState('cnv');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ genome, dataType });
  };

  return (
    <div className="WSNG-modal-overlay">
      <div className="WSNG-modal-content">
        <h2 className="WSNG-modal-title"><i className="fas fa-project-diagram"></i> Single SV/CNV Analysis Settings</h2>
        <p className="WSNG-modal-description">Configure parameters for your structural variant analysis.</p>

        <form onSubmit={handleSubmit} className="WSNG-modal-form">
          <div className="WSNG-modal-fields">
            <section className="WSNG-modal-section">
              <div className="WSNG-modal-section-heading">
                <h3>Analysis Parameters</h3>
                <p>Select the reference genome and the type of variant.</p>
              </div>
              <div className="WSNG-modal-grid">
                <div className="WSNG-modal-form-group">
                  <label htmlFor="genome">Reference Genome</label>
                  <select
                    id="genome"
                    name="genome"
                    value={genome}
                    onChange={(e) => setGenome(e.target.value)}
                  >
                    <option value="GRCH38">GRCh38</option>
                    <option value="GRCH37">GRCh37</option>
                  </select>
                </div>

                <div className="WSNG-modal-form-group">
                  <label htmlFor="dataType">Data Type</label>
                  <select
                    id="dataType"
                    name="dataType"
                    value={dataType}
                    onChange={(e) => setDataType(e.target.value)}
                  >
                    <option value="cnv">Copy Number Variation (CNV)</option>
                    <option value="sv">Structural Variation (SV)</option>
                  </select>
                </div>
              </div>
            </section>
          </div>

          <div className="WSNG-modal-actions">
            <button type="button" className="WSNG-modal-btn secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="WSNG-modal-btn primary"><i className="fas fa-play"></i> Start Analysis</button>
          </div>
        </form>
      </div>
    </div>
  );
};


const Home = ({ accountId: accountIdProp, onSettingsClick }) => {
  // Detect theme from parent container
  const [theme, setTheme] = useState('dark');
  useEffect(() => {
    const container = document.querySelector('.WSNG-app-container');
    if (container) {
      const observer = new MutationObserver(() => {
        setTheme(container.classList.contains('light-theme') ? 'light' : 'dark');
      });
      observer.observe(container, { attributes: true, attributeFilter: ['class'] });
      setTheme(container.classList.contains('light-theme') ? 'light' : 'dark');
      return () => observer.disconnect();
    }
  }, []);
  const logoSrc = theme === 'light' ? logoLight : logoDark;

  /* ───────────────────────────────────
     Knowledge-base counts (static demo)
  ─────────────────────────────────── */
  const [dbStats] = useState({
    evidence: 11148,
    molecularprofiles: 4016,
    variants: 3890,
    therapies: 578,
    diseases: 435,
    assertions: 169
  });

  /* ───────────────────────────────────
     Jobs / Uploads panel
  ─────────────────────────────────── */
  const [savedUploads, setSavedUploads] = useState([]);
  const [selectedUpload, setSelectedUpload] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  /* ───────────────────────────────────
     Search + mode + submit/poll
  ─────────────────────────────────── */
  const [mode, setMode] = useState('gene');
  const [isModeMenuOpen, setIsModeMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [jobId, setJobId] = useState(null);
  const [jobStatus, setJobStatus] = useState(null);
  const pollRef = useRef(null);
  const uploadPollRef = useRef(null);

  const fileInput = useRef(null);
  const modeDropdownRef = useRef(null);

  /* ───────────────────────────────────
     State for multi-variant uploads
  ─────────────────────────────────── */
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isParamsModalOpen, setIsParamsModalOpen] = useState(false);
  const [isSvCnvModalOpen, setIsSvCnvModalOpen] = useState(false);
  const [isSingleVariantModalOpen, setIsSingleVariantModalOpen] = useState(false);
  const [isSingleSvCnvModalOpen, setIsSingleSvCnvModalOpen] = useState(false);
  const [pendingUpload, setPendingUpload] = useState(null); // { job_id, filename, mode }
  const [pendingSearchQuery, setPendingSearchQuery] = useState(''); // for single-variant and single-sv-cnv
  const [accountId, setAccountId] = useState(accountIdProp || '');

  useEffect(() => {
    if (accountIdProp) {
      setAccountId(accountIdProp);
      return;
    }
    try {
      const cookie = ensureNewGenomeProCookie();
      if (cookie?.id) {
        setAccountId(cookie.id);
      }
    } catch (err) {
      console.error('Unable to ensure NewGenome cookie', err);
    }
  }, [accountIdProp]);

  const resolveAccountId = useCallback(() => {
    if (accountId) return accountId;
    try {
      const cookie = ensureNewGenomeProCookie();
      if (cookie?.id) {
        setAccountId(cookie.id);
        return cookie.id;
      }
    } catch (err) {
      console.error('Unable to resolve account id', err);
    }
    return '';
  }, [accountId]);

  // Fetch job history
  const refreshSavedUploads = async () => {
    try {
      const account_id = resolveAccountId();
      if (!account_id) {
        console.warn('Missing account id; skipping job history fetch');
        return;
      }
      const resp = await fetch(`${getApiEndpoint('jobsByAccount')}?account_id=${account_id}`);
      if (!resp.ok) throw new Error('jobsByAccount failed');
      const rows = await resp.json();
const mapped = rows.map(r => ({
  uuid: r.job_id,
  job_id: r.job_id,
  job_type: r.job_type,
  input_text: r.input_text,
  original_files: r.input_text,
  status: r.status,
  upload_time: r.created_at,
  pipelines_completed_time: r.finished_at,
  is_demo: Number(r.is_demo) === 1, // <-- keep demo flag
  files: []
}));

      setSavedUploads(mapped);
    } catch (e) {
      console.error('Error fetching saved uploads:', e);
      setSavedUploads([]);
    }
  };

  useEffect(() => {
    refreshSavedUploads();

    // Start persistent polling for upload status updates every 10 seconds
    uploadPollRef.current = setInterval(() => {
      refreshSavedUploads();
    }, 10000);

    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
      if (uploadPollRef.current) clearInterval(uploadPollRef.current);
    };
  }, [resolveAccountId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modeDropdownRef.current && !modeDropdownRef.current.contains(event.target)) {
        setIsModeMenuOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsModeMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  // Modal open helper
  const openResultsModal = async (item) => {
    // Open modal immediately with loading state
    setSelectedUpload({ ...item, files: item.files || [], isLoading: true });
    setIsModalOpen(true);

    // Fetch files in the background if needed
    if (item.job_id && (!item.files || item.files.length === 0)) {
      try {
        const res = await fetch(`${getApiEndpoint('jobResult')}/${item.job_id}`);
        if (res.ok) {
          const data = await res.json();
          // Update the modal content with fetched files
          setSelectedUpload({ ...item, files: data.files || [], isLoading: false });
          return;
        }
      } catch (e) {
        console.error('fetch jobResult error', e);
        setSelectedUpload({ ...item, files: [], isLoading: false, error: 'Failed to load files' });
      }
    } else {
      // No need to fetch, just remove loading state
      setSelectedUpload({ ...item, isLoading: false });
    }
  };

  // File handling and chunking logic
  const CHUNK_SIZE = 15 * 1024 * 1024; // 5 MB

  const handleFiles = async (files) => {
    if ((mode !== 'multi-variant' && mode !== 'multi-sv-cnv') || isFileUploading) return;
    const file = files[0];
    if (!file) return;

    setIsFileUploading(true);
    setUploadProgress(0);

    try {
      // STEP 1: Get a job_id from the server
      const initResponse = await fetch(getApiEndpoint('initializeUpload'), { method: 'POST' });
      const { job_id } = await initResponse.json();
      if (!initResponse.ok || !job_id) {
        throw new Error('Could not initialize upload.');
      }

      // STEP 2: Upload chunks with the server-provided job_id
      const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
      for (let i = 0; i < totalChunks; i++) {
        const start = i * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append('chunk', chunk);
        formData.append('chunkIndex', i);
        formData.append('job_id', job_id);

        const response = await fetch(getApiEndpoint('uploadChunk'), {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Chunk ${i + 1} failed to upload.`);
        }
        setUploadProgress(Math.round(((i + 1) / totalChunks) * 100));
      }

      setIsFileUploading(false);
      setPendingUpload({ job_id, filename: file.name, mode });

      // Open appropriate modal based on mode
      if (mode === 'multi-sv-cnv') {
        setIsSvCnvModalOpen(true);
      } else {
        setIsParamsModalOpen(true);
      }
    } catch (error) {
      console.error(error);
      setIsFileUploading(false);
      alert('File upload failed. Please try again.');
    }
  };

  const onDrop = e => { e.preventDefault(); handleFiles(e.dataTransfer.files); };

  // Called from the parameter modal to finalize the job
  const handleFinalizeUpload = async (parameters) => {
    if (!pendingUpload) return;

    try {
      const account_id = resolveAccountId();
      if (!account_id) {
        throw new Error('Missing account id');
      }

      const body = {
          job_id: pendingUpload.job_id,
          account_id,
          parameters: parameters,
          original_filename: pendingUpload.filename
      };

      const response = await fetch(getApiEndpoint('finalizeUpload'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'Failed to finalize upload.');

      // Clean up all upload-related state
      setIsParamsModalOpen(false);
      setPendingUpload(null);
      setUploadProgress(0);
      if (fileInput.current) fileInput.current.value = '';

      // Fetch uploads immediately after successful submission
      await refreshSavedUploads();

    } catch (error) {
      console.error('Finalization error:', error);
      alert('Failed to submit job.');
    }
  };

  // Called from the SV/CNV modal to finalize the job
  const handleFinalizeSvCnv = async (parameters) => {
    if (!pendingUpload) return;

    try {
      const account_id = resolveAccountId();
      if (!account_id) {
        throw new Error('Missing account id');
      }

      const body = {
          job_id: pendingUpload.job_id,
          account_id,
          parameters: { ...parameters, job_type: 'multi-sv-cnv' },
          original_filename: pendingUpload.filename
      };

      const response = await fetch(getApiEndpoint('finalizeUpload'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'Failed to finalize upload.');

      // Clean up all upload-related state
      setIsSvCnvModalOpen(false);
      setPendingUpload(null);
      setUploadProgress(0);
      if (fileInput.current) fileInput.current.value = '';

      // Fetch uploads immediately after successful submission
      await refreshSavedUploads();

    } catch (error) {
      console.error('Finalization error:', error);
      alert('Failed to submit job.');
    }
  };

  // Called from SingleVariantModal to submit the job
  const handleSingleVariantSubmit = async (parameters) => {
    setIsSingleVariantModalOpen(false);
    await submitAnalysisJob({
      input_text: pendingSearchQuery,
      genome: parameters.genome
    });
    setPendingSearchQuery('');
  };

  // Called from SingleSvCnvModal to submit the job
  const handleSingleSvCnvSubmit = async (parameters) => {
    setIsSingleSvCnvModalOpen(false);
    await submitAnalysisJob({
      input_text: pendingSearchQuery,
      genome: parameters.genome,
      dataType: parameters.dataType
    });
    setPendingSearchQuery('');
  };

  const getFileTypeInfo = (item) => {
    const meta = getJobTypeMeta(item?.job_type);
    if (meta) {
      return { icon: meta.icon, cssClass: meta.cssClass || '', label: meta.label };
    }

    const filename = item.original_files?.toLowerCase() || '';
    if (filename.includes('vcf') || filename.includes('.vcf.gz')) {
      return { icon: 'fa-file-medical-alt', cssClass: 'vcf', label: 'VCF File' };
    }
    if (
      filename.includes('chr') &&
      (filename.includes('_del') || filename.includes('_dup') || filename.match(/\d+_[atcg]_[atcg]/i))
    ) {
      return { icon: 'fa-dna', cssClass: 'variant', label: 'Variant' };
    }
    if (filename.match(/^[a-z0-9]+$/i) || filename.includes('gene')) {
      return { icon: 'fa-dna', cssClass: 'gene', label: 'Gene' };
    }
    return { icon: 'fa-file-alt', cssClass: '', label: 'Analysis' };
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  // Submit + poll for single gene/variant/sv
  const runAnalysis = async () => {
    if (!searchQuery.trim()) return;

    // For single-variant and single-sv-cnv, show parameter modal first
    if (mode === 'single-variant') {
      setPendingSearchQuery(searchQuery.trim());
      setIsSingleVariantModalOpen(true);
      return;
    }

    if (mode === 'single-sv-cnv') {
      setPendingSearchQuery(searchQuery.trim());
      setIsSingleSvCnvModalOpen(true);
      return;
    }

    // For gene mode, submit directly
    await submitAnalysisJob({ input_text: searchQuery.trim() });
  };

  // Actual submission logic
  const submitAnalysisJob = async (params) => {
    // Clear previous job state to allow new submission
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
    setJobId(null);
    setJobStatus(null);

    try {
      const account_id = resolveAccountId();
      if (!account_id) {
        throw new Error('Missing account id');
      }
      const body = {
        account_id,
        job_type: mode,
        input_text: params.input_text,
        genome: params.genome || 'GRCH38',
        gender: 'Unknown',
        ...(params.dataType && { dataType: params.dataType })
      };
      const r = await fetch(getApiEndpoint('submitJob'), {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(body)
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.error || 'submit failed');

      const id = j.job_id;
      setJobId(id);
      setJobStatus(j.status || (j.from_cache ? j.status : 'queued'));

      // Fetch uploads immediately after successful submission
      await refreshSavedUploads();

      // Poll for status updates
      pollRef.current = setInterval(async () => {
        try {
          const rr = await fetch(`${getApiEndpoint('jobStatus')}/${id}`);
          const jj = await rr.json();
          if (!rr.ok) throw new Error(jj.error || 'status error');
          setJobStatus(jj.status);

          if (jj.status === 'completed' || jj.status === 'failed') {
            clearInterval(pollRef.current);
            pollRef.current = null;
            setJobId(null);
            setJobStatus(null);
            await refreshSavedUploads();
          }
        } catch (e) {
          console.error(e);
          clearInterval(pollRef.current);
          pollRef.current = null;
        }
      }, 5000);
    } catch (e) {
      console.error(e);
      setJobId(null);
      setJobStatus(null);
    }
  };

  const messages = [
    'Accelerating precision oncology insights',
    'Seamless knowledge for clinicians',
    'Welcome back, stay curious'
  ];
  const [currentMessage, setCurrentMessage] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setCurrentMessage(i => (i + 1) % messages.length), 4000);
    return () => clearInterval(id);
  }, []);

  const latestUpdates = [
    { id: 1, type: 'database',    component: 'Comprehensive variant annotation', date: '', description: 'HGVSc, HGVSp, consequences on proteins, clinical evidence, global allele frequency, prediction scores.' },
    { id: 2, type: 'feature',     component: 'Multi-omics insights', date: '', description: 'Insights of eQTL, pQTL, GWAS, MR, and PGx.' },
    { id: 3, type: 'integration', component: 'Diverse functions',      date: '', description: 'Pathway enrichment, biological network interactions, and variant prioritizations using VarXOmics and Exomiser.' },
    { id: 4, type: 'feature',      component: 'Visualizations',    date: '', description: 'Downloadable publication-ready figures and structured tabular data.' }
  ];

  const modeOptions = JOB_TYPE_ORDER.map(value => {
    const meta = JOB_TYPE_METADATA[value];
    return {
      value,
      label: meta.label,
      placeholder: meta.placeholder,
      description: meta.description,
      icon: meta.icon
    };
  });

  const activeMode = modeOptions.find(opt => opt.value === mode) || modeOptions[0];
  const placeholder = activeMode.placeholder;
  const modeDisplay = activeMode.label;
  const modeMenuId = 'wsng-mode-menu';

  const handleModeSelect = (value) => {
    setMode(value);
    setSearchQuery('');
    setIsModeMenuOpen(false);
  };

  return (
    <div className="WSNG-home" onDragOver={e => e.preventDefault()} onDrop={onDrop}>
      <header className="WSNG-home-header">
        <div className="WSNG-welcome-container">
          <div className="WSNG-welcome-logo-wrapper">
            <img src={logoSrc} alt="VarXOmics Logo" className="WSNG-welcome-logo" />
          </div>
          <div className="WSNG-welcome-text">
            <h1>Welcome to VarXOmics</h1>
            <p>Advanced web server for genomic data querying and variant prioritizing with multi-omics insights.</p>
          </div>
        </div>
      </header>

      <main className="WSNG-home-content">
        <section className="WSNG-left-column">

          <div className="WSNG-section-less WSNG-kb-stats-section">
            <h2><i className="fas fa-search"></i>Search or Upload</h2>

            <div className="WSNG-search-wrapper">
              <input
                className="WSNG-search-bar"
                type="text"
                placeholder={placeholder}
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                disabled={mode === 'multi-variant' || mode === 'multi-sv-cnv'}
              />
              <div
                className={`WSNG-mode-chip ${isModeMenuOpen ? 'open' : ''}`}
                ref={modeDropdownRef}
              >
                <button
                  type="button"
                  className="WSNG-mode-chip-button"
                  onClick={() => setIsModeMenuOpen(prev => !prev)}
                  aria-haspopup="listbox"
                  aria-expanded={isModeMenuOpen}
                  aria-controls={modeMenuId}
                >
                  <span className="WSNG-mode-chip-label">{modeDisplay}</span>
                </button>
                {isModeMenuOpen && (
                  <div className="WSNG-mode-menu" role="listbox" id={modeMenuId}>
                    {modeOptions.map(opt => (
                      <button
                        key={opt.value}
                        type="button"
                        role="option"
                        aria-selected={mode === opt.value}
                        className={`WSNG-mode-menu-item ${mode === opt.value ? 'active' : ''}`}
                        onClick={() => handleModeSelect(opt.value)}
                      >
                        <span className="WSNG-mode-menu-title">{opt.label}</span>
                        <span className="WSNG-mode-menu-desc">{opt.description}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {(mode === 'multi-variant' || mode === 'multi-sv-cnv') && (
              <div className="WSNG-filedrop" onClick={() => !isFileUploading && fileInput.current?.click()}>
                <p>{isFileUploading ? `Uploading... ${uploadProgress}%` : 'Drop VCF.gz file here or click to browse'}</p>
                <input
                  ref={fileInput}
                  type="file"
                  accept=".vcf,.vcf.gz,.gz,application/gzip"
                  style={{ display: 'none' }}
                  onChange={e => handleFiles(e.target.files)}
                  disabled={isFileUploading}
                />
                {isFileUploading && <div className="WSNG-upload-progress-bar" style={{ width: `${uploadProgress}%` }}></div>}
              </div>
            )}

            <div className="WSNG-run-btns">
              <button className="WSNG-run-btn" onClick={runAnalysis} disabled={mode === 'multi-variant' || mode === 'multi-sv-cnv' || isFileUploading}>
                <i className="fas fa-play"></i> <div> RUN </div>
              </button>
            </div>

          </div>

          <div className="WSNG-section WSNG-uploads-section">
            <h2><i className="fas fa-history"></i>Uploads</h2>
            <div className="WSNG-saved-uploads">
              {savedUploads.length === 0 ? (
                <p className="WSNG-empty-note">No analysis results found.</p>
              ) : (
                <div className="WSNG-upload-list WSNG-saved-list">
                  {savedUploads.map((item, idx) => {
                    const typeInfo = getFileTypeInfo(item);
                    const typeClass = typeInfo.cssClass || '';
                    const typeIcon = typeInfo.icon || 'fa-file-alt';
                    const jobTypeLabel = typeInfo.label || formatJobTypeLabel(item.job_type);
                    const jobIdentifier = item.uuid || item.job_id || '';
                    const summaryLine = [jobTypeLabel, jobIdentifier].filter(Boolean).join(' | ');
                    const isDemo = item.is_demo || /^\[DEMO\]/i.test(item.original_files || '');

                    const idForCard = item.uuid || item.job_id || idx;
                    const statusValue = (item.status || 'completed').toLowerCase();
                    const inProgressStatuses = ['running', 'queued', 'processing'];
                    const isLockedStatus = inProgressStatuses.includes(statusValue);
                    const statusLabel = statusValue
                      .split(/[\s_]+/)
                      .filter(Boolean)
                      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
                      .join(' ') || 'Completed';
                    const statusIconClass = (() => {
                      if (inProgressStatuses.includes(statusValue)) {
                        return 'fas fa-circle-notch fa-spin';
                      }
                      if (statusValue === 'completed') {
                        return 'fas fa-check-circle';
                      }
                      if (statusValue === 'failed' || statusValue === 'error') {
                        return 'fas fa-exclamation-triangle';
                      }
                      return 'fas fa-info-circle';
                    })();
                    return (
                      <div
                        key={idForCard}
                        className={`WSNG-upload-item WSNG-saved-item ${typeClass} ${isLockedStatus ? 'disabled' : ''}`}
                        onClick={isLockedStatus ? undefined : () => openResultsModal(item)}
                        aria-disabled={isLockedStatus}
                      >
                        <div className="WSNG-saved-item-header">
                          <div className="WSNG-saved-item-main">
                            <div className="WSNG-saved-item-icon">
                              <i className={`fas ${typeIcon}`}></i>
                            </div>
                            <div className="WSNG-saved-item-content">
                              <div className="WSNG-saved-item-title-container">
                          <div className="WSNG-saved-item-title">
  {item.original_files}
  {isDemo && <span className="WSNG-badge WSNG-badge-demo" title="Demo job">DEMO</span>}
</div>

                                {item.notes && <div className="WSNG-saved-item-notes">{item.notes}</div>}
                              </div>
                              <div className="WSNG-saved-item-uuid">{summaryLine}</div>
                            </div>
                          </div>
                        </div>

                        <div className="WSNG-saved-item-details">

                          <div className="WSNG-saved-item-detail">
                            <div className="WSNG-saved-item-detail-label">Uploaded</div>
                            <div className="WSNG-saved-item-detail-value">
                              {formatDate(item.upload_time)}
                            </div>
                          </div>
                          {(item.pipelines_completed_time || item.finished_at) && (
                            <div className="WSNG-saved-item-detail">
                              <div className="WSNG-saved-item-detail-label">Completed</div>
                              <div className="WSNG-saved-item-detail-value">
                                {formatDate(item.pipelines_completed_time || item.finished_at)}
                              </div>
                            </div>
                          )}
                          <div className="WSNG-saved-item-detail">
                            <div className="WSNG-saved-item-detail-label">Status</div>
                            <div className="WSNG-saved-item-detail-value">
                              <span className={`WSNG-saved-item-status ${statusValue}`}>
                                <i className={statusIconClass}></i>
                                {statusLabel}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </section>

        <aside className="WSNG-right-column">
          <div className="WSNG-section WSNG-updates-section">
            <h2><i className="fas fa-star"></i>Features</h2>
            <div className="WSNG-updates-list">
              {latestUpdates.map(u => (
                <div key={u.id} className="WSNG-update-item">
                  <div className="WSNG-update-icon">
                    <i className={`fas fa-${u.type === 'database' ? 'database' : u.type === 'feature' ? 'star' : u.type === 'integration' ? 'plug' : 'sync'}`}/>
                  </div>
                  <div className="WSNG-update-content">
                    <div className="WSNG-update-header">
                      <h4>{u.component}</h4>
                      {u.date && <span className="WSNG-update-date">{u.date}</span>}
                    </div>
                    <p>{u.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="WSNG-resources-container">
              <h2><i className="fas fa-life-ring"></i>Additional Resources</h2>
              <div className="WSNG-resources-grid">
                <Resource
                  icon="cogs"
                  title="Settings"
                  text="Configure application preferences, API connections, and user access"
                  btn="Open Settings"
                  onClick={onSettingsClick}
                />
                <Resource
                  icon="question-circle"
                  title="Help & Support"
                  text="Access documentation, tutorials, and contact technical support"
                  btn="View Help"
                  link="https://xinmengliao.github.io/PhenomePortal-VarXOmics/Intro/"
                  
                />
              </div>
            </div>
          </div>
        </aside>
      </main>

      <ResultsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={selectedUpload}
      />

      <MultiVariantModal
        isOpen={isParamsModalOpen}
        onClose={() => {
          setIsParamsModalOpen(false);
          setPendingUpload(null);
        }}
        onSubmit={handleFinalizeUpload}
      />

      <MultiSvCnvModal
        isOpen={isSvCnvModalOpen}
        onClose={() => {
          setIsSvCnvModalOpen(false);
          setPendingUpload(null);
        }}
        onSubmit={handleFinalizeSvCnv}
      />

      <SingleVariantModal
        isOpen={isSingleVariantModalOpen}
        onClose={() => {
          setIsSingleVariantModalOpen(false);
          setPendingSearchQuery('');
        }}
        onSubmit={handleSingleVariantSubmit}
      />

      <SingleSvCnvModal
        isOpen={isSingleSvCnvModalOpen}
        onClose={() => {
          setIsSingleSvCnvModalOpen(false);
          setPendingSearchQuery('');
        }}
        onSubmit={handleSingleSvCnvSubmit}
      />
    </div>
  );
};

const Resource = ({ icon, title, text, btn, link, onClick }) => (
  <div className="WSNG-resource-card">
    <div className="WSNG-resource-icon"><i className={`fas fa-${icon}`}/></div>
    <div className="WSNG-resource-content">
      <h3>{title}</h3><p>{text}</p>
      {link ? (
        <a href={link} target="_blank" rel="noreferrer" className="WSNG-resource-button">
          <i className="fas fa-arrow-right" />{btn}
        </a>
      ) : (
        <button className="WSNG-resource-button" onClick={onClick}><i className="fas fa-arrow-right" />{btn}</button>
      )}
    </div>
  </div>
);

export default Home;
